<template>
  <div>
    <!-- 品名编辑 -->
    <div class="productNameEditor">
      <div class="table">
        <ol>
          <!-- 番号 -->
          <li class="flex05">{{ $t('message.mash') }}</li>
          <li class="flex05">{{ $t("message.choose") }}</li>
          <!-- 商品图片 -->
          <li class="flex05">
            {{ $t("message.productPicture") }}
          </li>
          <!-- 属性 -->
          <li>{{ $t("message.property") }}</li>
          <!-- 店铺信息 -->
          <li>
            {{ $t("message.storeInformation") }}
          </li>
          <!-- 中文商品名 -->
          <li>{{ $t("message.chineseProductName") }}</li>
          <!-- 中文商品描述 -->
          <li>{{ $t("message.productDescriptionInChineses") }}（用途）</li>
          <!-- 品名（CN） -->
          <li>{{ $t("message.material") }}（CN）</li>
          <!-- 材质 （CN）-->
          <li>{{ $t("message.texture") }}（CN）</li>

          <!-- 品名（JP） -->
          <li>{{ $t("message.material") }}（JP）</li>
          <!-- 材质（JP） -->
          <li>{{ $t("message.texture") }}（JP）</li>
          <!-- 用途 （EN）-->
          <li>{{ $t("message.use") }}（EN）</li>
          <!-- 品名（EN）-->
          <li>{{ $t("message.material") }}（EN）</li>
          <!-- 材质 （EN）-->
          <li>{{ $t("message.texture") }}（EN）</li>
          <!-- HS编码 -->
          <li>{{ $t("message.HScode") }}</li>

          <!--默认信息来源-->
          <li>{{ $t("message.defaultInformationSource") }}</li>
        </ol>
        <ul v-for="(item, index) in order_detail_material" :key="index">
          <li class="flex05">{{ item.sorting }}</li>
          <li class="flex05">
            <el-checkbox v-model="item.checked" @change="changeRadio"></el-checkbox>
          </li>
          <!-- 照片 -->
          <li class="flex05">
            <el-popover placement="right" width="300" trigger="hover">
              <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
              <a :href="item.link" slot="reference" target="_blank">
                <el-image :src="item.pic" style="width: 56px; height: 56px; border-radius: 4px">
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
              </a>
            </el-popover>
          </li>
          <!-- 属性 -->
          <li>
            <div class="template">
              <p v-for="(detail) in item.detail_y">
                {{ detail.key }}:{{ detail.value }}
              </p>
            </div>
          </li>
          <!-- 店铺信息 -->
          <li>
            <div class="template">
              <p>{{ item.shop_name }}</p>
              <p style="color: #15ad3c">{{ item.from_platform }}</p>
              <p>{{ item.shop_id }}</p>
            </div>
          </li>

          <!-- 中文商品名 -->
          <li>{{ item.goods_title }}</li>
          <!-- 中文商品描述 -->
          <li>
            <el-input type="textarea" placeholder="请输入内容" v-model="item.desc_cn" show-word-limit resize="none"
              @input="allEdit(item.checked, 'desc_cn', item.desc_cn)">
            </el-input>
          </li>
          <!-- 品名（CN） @blur="get_goods_name_cn(item.checked, item.goods_name_cn, index)" -->
          <li>
            <el-input type="textarea" placeholder="请输入内容" v-model="item.goods_name_cn" show-word-limit resize="none"
              @input="allEdit(item.checked, 'goods_name_cn', item.goods_name_cn)">
            </el-input>
          </li>
          <!-- 材质 （CN）  @blur="get_goods_material_cn(item.checked, item.goods_material_cn, index)"-->
          <li>
            <el-input type="textarea" placeholder="请输入内容" v-model="item.goods_material_cn" show-word-limit resize="none"
              @input="allEdit(item.checked, 'goods_material_cn', item.goods_material_cn)">
            </el-input>
          </li>

          <!-- 品名（JP） -->
          <li>
            <el-input type="textarea" placeholder="请输入内容" v-model="item.goods_name_jp" show-word-limit resize="none"
              @input="allEdit(item.checked, 'goods_name_jp', item.goods_name_jp)">
            </el-input>
          </li>
          <!-- 材质（JP） -->
          <li>
            <el-input type="textarea" placeholder="请输入内容" v-model="item.goods_material_jp" show-word-limit resize="none"
              @input="allEdit(item.checked, 'goods_material_jp', item.goods_material_jp)">
            </el-input>
          </li>
          <!-- 用途 （EN）-->
          <li>
            <el-input type="textarea" placeholder="请输入内容" v-model="item.desc_en" show-word-limit resize="none"
              @input="allEdit(item.checked, 'desc_en', item.desc_en)">
            </el-input>
          </li>
          <!-- 品名（EN）-->
          <li>
            <el-input type="textarea" placeholder="请输入内容" v-model="item.goods_name_en" show-word-limit resize="none"
              @input="allEdit(item.checked, 'goods_name_en', item.goods_name_en)">
            </el-input>
          </li>
          <!-- 材质 （EN）-->
          <li>
            <el-input type="textarea" placeholder="请输入内容" v-model="item.goods_material_en" show-word-limit resize="none"
              @input="allEdit(item.checked, 'goods_material_en', item.goods_material_en)">
            </el-input>
          </li>
          <!-- HS编码 -->
          <li>
            <el-input type="textarea" placeholder="请输入内容" v-model="item.hs_code" show-word-limit resize="none"
              @input="allEdit(item.checked, 'hs_code', item.hs_code)">
            </el-input>
          </li>
          <!--默认信息来源-->
          <li>{{ item.status }}</li>
        </ul>
      </div>
      <!-- 操作 -->
      <div class="operate">
        <!--全选  -->
        <el-checkbox v-model="checked" style="margin-right: 30px" @change="allChecked">{{ $t("message.allChecked")
        }}</el-checkbox>
        <!-- 同ID商品 -->
        <el-button type="primary" class="secondary" @click="sameID">{{ $t("message.productWithTheSameId") }}
        </el-button>
        <!-- 同店铺商品 -->
        <el-button type="primary" class="secondary" @click="sameShop">{{ $t("message.sameStoreProduct") }}
        </el-button>
        <!--  AI自动获取-->
        <el-button type="primary" @click="translate">{{ $t("message.AIAutomaticAcquisition") }}
        </el-button>
        <!-- 商品监控录入 -->
        <el-button type="success" @click="commodityMonitoringEntry">
          {{ $t("message.commodityMonitoringEntry") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" class="fr" @click="setOrderMaterial">{{ $t("message.save") }}
        </el-button>
      </div>
    </div>
    <!-- 商品监控录入弹窗 -->
    <monitorProductSettings ref="monitorProductSettings" :checkedList="checkedList"></monitorProductSettings>
  </div>
</template>
<script>
import monitorProductSettings from '../../orderDetail/components/monitorProductSettings.vue'
export default {
  components: {
    monitorProductSettings,
  },
  data() {
    return {
      textarea: "",
      checked: false,
      detail: {},
      porder_sn: this.$route.query.porder_sn,
      order_detail_material: [],
      checkedList: [],
    };
  },
  created() {

    this.orderMaterialPreview();
  },
  methods: {
    // 获取列表
    orderMaterialPreview() {
      this.$api.porderApi
        .orderMaterialPreview({
          porder_sn: this.porder_sn,
        })
        .then((res) => {
          this.order_detail_material = [];
          res.data.forEach((item) => {
            item.checked = false;
            let itemData = {};
            if (item.order_detail_material != null) {
              itemData = item.order_detail_material;
              itemData.status = "自己录入";
            } else if (item.personal_material != null) {
              itemData = item.personal_material;
              itemData.status = "客户历史录入";
            } else if (item.standard_material != null) {
              itemData = item.standard_material;
              itemData.status = "标准信息";
            } else if (item.history_material_self != null) {
              itemData = item.history_material_self;
              itemData.status = "自己历史录入";
            } else if (item.history_material_other != null) {
              itemData = item.history_material_other;
              itemData.status = "其他业务录入";
            } else {
              itemData = {
                goods_material_cn: "",
                goods_material_en: "",
                goods_material_jp: "",
                goods_name_cn: "",
                goods_name_en: "",
                goods_name_jp: "",
                desc_cn: "",
                desc_en: "",
                status: "未录入",
                hs_code: '',
              };
            }
            itemData.detail_y = item.detail_y;
            itemData.goods_id = item.goods_id;
            itemData.goods_title = item.goods_title;
            itemData.shop_id = item.shop_id;
            itemData.shop_name = item.shop_name;
            itemData.sku_id = item.sku_id;
            itemData.pic = item.pic;
            itemData.checked = false;
            itemData.order_detail_id = item.id;
            itemData.sorting = item.sorting;
            itemData.link = item.link;
            itemData.from_platform = item.from_platform;
            this.order_detail_material.push(itemData);
          });
          this.detail = res.data;

        });
    },
    // 全选
    allChecked() {
      this.order_detail_material.forEach((item) => {
        item.checked = this.checked;
      });
    },
    // 单选
    changeRadio() {
      this.checked = this.order_detail_material.every((item) => item.checked);
    },
    // 同店铺商品
    sameShop() {
      let list = [];
      this.order_detail_material.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });

      list.forEach((item) => {
        this.order_detail_material.forEach((items) => {
          if (item.shop_id == items.shop_id) {
            items.checked = true;

          }
        });
      });
      this.$forceUpdate();
    },
    // 同ID商品
    sameID() {
      let list = [];
      this.order_detail_material.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });

      list.forEach((item) => {
        this.order_detail_material.forEach((items) => {
          if (item.goods_id == items.goods_id) {
            items.checked = true;

          }
        });
      });
      this.$forceUpdate();
    },
    // 保存
    setOrderMaterial() {
      let datas = {
        porder_sn: this.porder_sn,
        list: JSON.stringify(this.order_detail_material),
      };
      console.log(this.order_detail_material);
      let str = ''
      this.order_detail_material.forEach(item => {
        if (item.goods_name_cn == '') {
          str += `<p>NO${item.sorting}:品名未编辑。</p>`
        }
      })

      if (str) {
        this.$alert(`<div style='height:500px; overflow-y:auto;'>${str}</div>`, '', {
          dangerouslyUseHTMLString: true
        }).then((action) => {
          this.$api.porderApi.setOrderMaterial(datas).then((res) => {
            this.$message.success(res.msg);
            this.$parent.isOrder = true;
            this.$parent.orderMaterialPreview();
          });
        })
      } else {
        this.$api.porderApi.setOrderMaterial(datas).then((res) => {
          this.$message.success(res.msg);
          this.$parent.isOrder = true;
          this.$parent.orderMaterialPreview();
        });
      }
    },

    //勾选的一起修改
    allEdit(checked, type, value) {
      if (checked) {
        this.order_detail_material.forEach((item) => {
          if (item.checked) {
            item[type] = value;
          }
        });
      }
      this.$forceUpdate();
    },
    //翻译
    get_goods_name_cn(value) {
      let datas = {
        k: value,
      }
      this.$api.getHscode(datas).then(res => {
        if (res.data == false) return this.$message.error(res.msg)
        let list = res.data.choices[0].message.content.split('||')
        this.order_detail_material.forEach((item) => {
          if (item.checked && item.goods_name_cn == value) {
            item.hs_code = list[0].split(':')[1]
            item.goods_name_en = list[2].split(':')[1]
            item.goods_name_jp = list[3].split(':')[1]
            item.desc_cn = list[7].split(':')[1]
            item.desc_en = list[8].split(':')[1]
            item.desc_jp = list[9].split(':')[1]
          }
        });
        this.$forceUpdate();
      })
    },
    //翻译
    get_goods_material_cn(value) {
      let datas = {
        k: value,
      }
      this.$api.getHscode(datas).then(res => {
        if (res.data == false) return this.$message.error(res.msg)
        let list = res.data.choices[0].message.content.split('||')
        this.order_detail_material.forEach((item) => {
          if (item.checked && item.goods_material_cn == value) {
            item.goods_material_en = list[5].split(':')[1]
            item.goods_material_jp = list[6].split(':')[1]
          }
        });
        this.$forceUpdate();
      })


    },
    // 翻译
    translate() {
      let goods_name_cn_list = []
      let goods_material_cn_list = []
      this.order_detail_material.forEach((item) => {
        if (item.checked) {
          if (item.goods_name_cn) {
            goods_name_cn_list.push({
              goods_name_cn: item.goods_name_cn,
            })
          }
          if (item.goods_material_cn) {
            goods_material_cn_list.push({
              goods_material_cn: item.goods_material_cn
            })
          }
        }
      });
      // 去重goods_name_cn
      var hash = {};
      goods_name_cn_list = goods_name_cn_list.reduce(function (item, next) {
        hash[next.goods_name_cn]
          ? ""
          : (hash[next.goods_name_cn] = true && item.push(next));

        return item;
      }, []);
      // 去重goods_material_cn
      var hashing = {};
      goods_material_cn_list = goods_material_cn_list.reduce(function (item, next) {
        hashing[next.goods_material_cn]
          ? ""
          : (hashing[next.goods_material_cn] = true && item.push(next));
        return item;
      }, []);
      goods_name_cn_list.forEach(item => {
        this.get_goods_name_cn(item.goods_name_cn)
      })
      goods_material_cn_list.forEach(item => {
        this.get_goods_material_cn(item.goods_material_cn)
      })

    },
    //商品监控
    commodityMonitoringEntry() {
      this.checkedList = []
      this.order_detail_material.forEach((item) => {
        if (item.checked) {
          console.log(item)
          this.checkedList.push(item)
        }
      });
      if (this.checkedList.length == 0) return this.$message.error("请选择商品")
      this.$refs.monitorProductSettings.dialogVisible = true
    },

  },
};
</script>
<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

.productNameEditor {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;
  margin: 24px;

  .table {
    font-size: 12px;

    ol {
      position: sticky;
      top: 0;
      left: 0;
      z-index: 9;
      display: flex;
      height: 40px;
      background: #edeff4;
      border-radius: 4px 4px 0px 0px;
      justify-content: center;
      align-items: center;

      li {
        height: 40px;
        text-align: center;
        align-items: center !important;
      }
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 24px;

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .flex2 {
      flex: 2;
    }

    .flex3 {
      flex: 3;
    }

    .flex15 {
      flex: 1.5;
    }

    ul {
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid #edeff4;
      transition: all 0.3s;

      &:hover {
        background-color: #fff;
      }

      .template {
        text-align: center;

        p {
          margin-bottom: 5px;
        }
      }

      .attribute {
        text-align: left;
        width: 100%;
        padding: 3%;

        .row {
          width: 100%;
          margin-bottom: 5px;
        }
      }

      /deep/.el-textarea__inner {
        height: 80px;
        padding: 5px;
      }
    }

    .purchase {
      background: #f0f0f0;
      text-align: center;
    }
  }

  .operate {
    position: sticky;
    bottom: 0;
    left: 0;
    z-index: 9;
    padding: 16px 24px;
    background: #edeff4;
    border-radius: 0px 0px 8px 8px;
  }
}
</style>